import axios from "axios";

const state = {
  downloads: [],
  unseenCount: 0,
  pollingInterval: null,
};

const getters = {
  downloads: (state) => state.downloads,
  unseenCount: (state) => state.unseenCount,
  readyDownloads: (state) => 
    state.downloads.filter(d => d.idx_status === 1 && d.seen === 0),
};

const mutations = {
  SET_DOWNLOADS(state, downloads) {
    state.downloads = downloads;
  },
  SET_UNSEEN_COUNT(state, count) {
    state.unseenCount = count;
  },
  SET_POLLING_INTERVAL(state, interval) {
    state.pollingInterval = interval;
  },
  CLEAR_POLLING_INTERVAL(state) {
    if (state.pollingInterval) {
      clearInterval(state.pollingInterval);
      state.pollingInterval = null;
    }
  },
  MARK_AS_SEEN(state, downloadId) {
    const download = state.downloads.find(d => d.id === downloadId);
    if (download) {
      download.seen = 1;
    }
  },
};

const actions = {
  async fetchDownloads({ commit, rootState }) {
    try {
      const token = rootState.currentUser?.token;
      if (!token) {
        return;
      }

      const response = await axios.get(
        `${process.env.VUE_APP_URL_API}downloads`
      );

      if (response.data.status === true) {
        const downloads = response.data.datas || [];
        commit("SET_DOWNLOADS", downloads);
        
        // Calculer le nombre de téléchargements non vus avec idx_status = 1
        const unseenCount = downloads.filter(
          d => d.idx_status === 1 && d.seen === 0
        ).length;
        commit("SET_UNSEEN_COUNT", unseenCount);
      }
    } catch (error) {
    }
  },

  startPolling({ dispatch, commit, state }) {
    // Ne pas démarrer si déjà en cours
    if (state.pollingInterval) {
      return;
    }

    // Première récupération immédiate
    dispatch("fetchDownloads");

    // Puis toutes les 10 secondes
    const interval = setInterval(() => {
      dispatch("fetchDownloads");
    }, 10000);

    commit("SET_POLLING_INTERVAL", interval);
  },

  stopPolling({ commit }) {
    commit("CLEAR_POLLING_INTERVAL");
  },

  async markAsSeen({ commit, rootState }, downloadId) {
    try {
      const token = rootState.currentUser?.token;
      if (!token) {
        return;
      }

      await axios.put(
        `${process.env.VUE_APP_URL_API}downloads/${downloadId}/seen`,
        {}
      );

      commit("MARK_AS_SEEN", downloadId);
    } catch (error) {
    }
  },

  async markAllAsSeen({ rootState }) {
    try {
      const token = rootState.currentUser?.token;
      if (!token) {
        return;
      }

      await axios.put(
        `${process.env.VUE_APP_URL_API}downloads/seenAll`,
        {}
      );
    } catch (error) {
    }
  },

  async markAsDownloaded({ rootState }, downloadId) {
    try {
      const token = rootState.currentUser?.token;
      if (!token) {
        return;
      }

      await axios.put(
        `${process.env.VUE_APP_URL_API}downloads/${downloadId}/downloaded`,
        {}
      );
    } catch (error) {
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
